import { Capacitor, registerPlugin } from '@capacitor/core';

export interface AdtraceAttribution {
  trackerToken?: string | null; trackerName?: string | null; network?: string | null;
  campaign?: string | null; adgroup?: string | null; creative?: string | null;
  clickLabel?: string | null; adid?: string | null; costType?: string | null;
  costAmount?: number | null; costCurrency?: string | null;
}

interface AdtracePlugin {
  getStatus(): Promise<{ configured: boolean; environment: string; adid?: string | null }>;
  getAttribution(): Promise<AdtraceAttribution>;
  trackEvent(options: { eventToken: string }): Promise<void>;
  trackRevenue(options: { eventToken: string; revenue: number; currency: string; orderId?: string; parameters?: Record<string, string | number | boolean> }): Promise<void>;
  appWillOpenUrl(options: { url: string }): Promise<void>;
  setPushToken(options: { token: string }): Promise<void>;
}

const BookaAdtrace = registerPlugin<AdtracePlugin>('BookaAdtrace');

class AdtraceService {
  private get isAvailable() { return Capacitor.isNativePlatform(); }
  async getStatus() { return this.isAvailable ? BookaAdtrace.getStatus() : { configured: false, environment: 'web' }; }
  async getAttribution() { return this.isAvailable ? BookaAdtrace.getAttribution() : null; }
  async trackEvent(eventToken: string) {
    if (this.isAvailable && eventToken) await BookaAdtrace.trackEvent({ eventToken });
  }
  async trackRevenue(options: { eventToken: string; revenue: number; currency?: string; orderId?: string | null; parameters?: Record<string, string | number | boolean> }) {
    if (!this.isAvailable || !options.eventToken || !Number.isFinite(options.revenue) || options.revenue <= 0) return;
    await BookaAdtrace.trackRevenue({
      eventToken: options.eventToken,
      revenue: options.revenue,
      currency: options.currency || 'IRR',
      ...(options.orderId ? { orderId: options.orderId } : {}),
      ...(options.parameters ? { parameters: options.parameters } : {}),
    });
  }
  async appWillOpenUrl(url: string) {
    if (this.isAvailable && url) await BookaAdtrace.appWillOpenUrl({ url });
  }
  async setPushToken(token: string) {
    if (this.isAvailable && token) await BookaAdtrace.setPushToken({ token });
  }
}

export const adtraceService = new AdtraceService();
